<script>
import { eventBus } from '../../../../../../../../Pages/assets/eventBus';
import Swal from "sweetalert2";
import axios from "axios";
import { Inertia } from '@inertiajs/inertia';
import { piniaPlugin } from '../../../../../../../../Pages/stores';

export default {
    props: {
        item: {
            type: Object,
            default: {},
            required: true,
        },
        onMounted: {
            type: Function,
            required: true
        },
        classes: {
            type: String,
            required: true
        },
        showModal: {
            type: Function,
            required: true
        },
        index: {
            type: Number,
            required: true
        },
        routeType: {
            type: String,
            default: null
        },
        dataType: {
            type: String,
            default: null,
        }
    },
    computed: {
        userTypeAbbr() {
            return this.$page.props.auth.user.user_type_abbr;
        },
        userType() {
            return this.$page.props.auth.user.user_type;
        }
    },
    setup() {
        const store = piniaPlugin();
        return { store };
    },
    methods: {
        renameFolderFileData() {
            let type = this.renameFolderFile.dataType
            let URL = (type === 'files') ? route(this.userTypeAbbr + '-vault-rename-data-file') : route(this.userTypeAbbr + '-vault-document-rename')
            this.$refs.topProgress.start()
            axios.post(URL, this.renameFolderFile, {})
            .then(response => {
                if(response.data.success == true) {
                    eventBus.reloadFolderFile('Rename', this.renameFolderFile.dataType);
                    this.isEdit = false
                    this.$toastr.s(response.data.message)
                }
                else {
                    this.$toastr.e(response.data.message) 
                }
                this.$refs.topProgress.done()
            })
            .catch(err => {
                this.$toastr.e(err.message);
                this.$refs.topProgress.done()
            })
        },
        editMode(val, name, docid, type) {
            this.isEdit = val 
            this.renameFolderFile.doc_name = name
            this.renameFolderFile.file_name = name.split(".")[0]
            this.renameFolderFile.ext = name.split(".")[1]
            this.renameFolderFile.doc_id = docid
            this.renameFolderFile.dataType = type
            setTimeout(() => {
                this.focusMe()
            }, 1000)
        },
        disableEditMode(val) {
            if(val == true){
                this.renameFolderFile.dataType === 'files' ? (this.renameFolderFile.file_name = this.renameFolderFile.file_name.trim()) : (this.renameFolderFile.doc_name = this.renameFolderFile.doc_name.trim())
                if(this.renameFolderFile.dataType === 'files' && this.renameFolderFile.file_name != '' || this.renameFolderFile.dataType === 'folders' && this.renameFolderFile.doc_name != '') {
                    this.renameFolderFileData()
                }
            } else {
                setTimeout(() => {
                    this.isEdit = false
                }, 500)
            }
        },
        focusMe() {
             this.$refs.rename.focus()
        },
        checkClickEvent(item, event, value = 0) {
            let val = 1
            
            if(!this.isEdit && value == 0) {
                this.click += val; 
            }

            setTimeout(() => {
                let filesFolderLength = (item.dataType == 'files') ? item.name.split(".").slice(0, -1).join(".").length : item.name.length;
                let isNameTruncated = false;
                if (!this.isEdit && value == 1) {
                    isNameTruncated = event.target.innerHTML.split(" ").includes("...")
                }

                if (this.click == 1 && value == 1 && filesFolderLength > 27 && isNameTruncated) {
                    event.target.innerHTML = item.name;
                }
                else {
                    if (this.click == 1) {
                        if (this.routeType === 'Trash') {
                            this.store.useTrashStore.restoreFolderFile(this.userTypeAbbr, item, "takeOutOfTrash");
                        }
                        else if ((('protected' in item) && item.protected) || (('hasPassword' in item) && item.hasPassword)) {
                            this.showModal(`Confirm password to unlock ''${item.name}''`, 'unlock', item)
                        }
                        else {
                            localStorage.getID = JSON.stringify(item.id);
                            (item.dataType == 'files') ? window.open(item.viewUrl, '_blank') : Inertia.visit(item.viewUrl)
                        }
                    }
                    else if (this.click == 2 && item.isEditDeleteUpload && !(('hasPassword' in item) && item.hasPassword)) {
                        this.editMode(true, item.name, item.id, item.dataType)
                    }
                }
                this.click = 0
            }, 500)
        }
    },
    data() {
        return {
            isBlinkCard: false,
            blinkCardID: null,
            isEdit: false,
            renameFolderFile: {
                doc_name: null,
                file_name: null,
                doc_id: 0,
                ext: null,
                dataType: null
            },
            click: 0
        }
    },
    mounted() {
        let fullURL = window.location.href.split("#");
        if(fullURL.length > 1) {
            this.$refs['scrollTop_' + this.blinkCardID]?.scrollIntoView({ behavior: 'smooth' })
            this.isBlinkCard = true
            this.blinkCardID = fullURL[1]
        }
        setTimeout(function() {
            window.history.pushState(null, null, fullURL[0])
            this.isBlinkCard = false
        }, 1000)

    }
};
</script>

<template>
    <div class="card shadow-none border" :ref="'scrollTop_' + blinkCardID" :class="{'blink': item.dataType === 'files' && blinkCardID == item.photoId && isBlinkCard}">
        <vue-topprogress ref="topProgress" :height="2"></vue-topprogress>
        <div class="card-body p-3">
                <div class="float-end ms-2">
                    <div class="d-flex flex-row gap-1">
                        <template v-if="(!(('protected' in item) && item.protected) && item.isEditDeleteUpload) || item.docType === 'Normal' || item.docType === 'Vault'">
                            <div v-if="!(('hasPassword' in item) && item.hasPassword)" class="p-2">
                                <input 
                                    @click.stop
                                    class="multipleSelect" 
                                    role="button" 
                                    type="checkbox" 
                                    :value="{ id: item.encryptedId, dataType: item.dataType, type: item.type }"
                                    v-model="store.useMultiSelect.selectedItems"
                                >
                            </div>
                        </template>
                        <b-dropdown
                            v-if="item.isEditDeleteUpload || (!item.isEditDeleteUpload && !(('hasPassword' in item) && item.hasPassword))"
                            toggle-class="font-size-16 text-muted p-0"
                            class="mb-2"
                            variant="white"
                            menu-class="dropdown-menu-end"
                            right
                        >
                            <template #button-content>
                                <i class="mdi mdi-dots-horizontal"></i>
                            </template>
                            <template v-if="routeType === 'Trash'">
                                <b-dropdown-item href="javascript:void(0)" @click="store.useTrashStore.restoreFolderFile(userTypeAbbr, item)">Restore</b-dropdown-item>
                                <b-dropdown-item href="javascript:void(0)" @click="store.useTrashStore.deleteFolderFile(userTypeAbbr, item)">Delete forever</b-dropdown-item>
                            </template>
                            <template v-else>
                                <template v-if="item.docType === 'own' && item.isEditDeleteUpload">
                                    <template v-if="!(('protected' in item) && item.protected)">
                                        <b-dropdown-item v-if="!(('hasPassword' in item) && item.hasPassword)" @click="editMode(true, item.name, item.id, item.dataType)" href="javascript:void(0)">Rename</b-dropdown-item>
                                        <b-dropdown-item href="javascript:void(0)" @click="showModal(`Set a password to protect ''${item.name}''`, 'protect', item)">Protect</b-dropdown-item>
                                        <b-dropdown-item v-if="!(('hasPassword' in item) && item.hasPassword)" href="Javascript:void(0)" @click="store.useMoveStore.showMoveModal(item)">Move</b-dropdown-item>
                                        <template v-if="userType != 4">
                                            <b-dropdown-item v-if="!(('hasPassword' in item) && item.hasPassword)" href="Javascript:void(0)" @click="store.useDeleteStore.multipleDeleteFolderFile(userTypeAbbr, item)">Delete</b-dropdown-item>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <b-dropdown-item href="javascript:void(0)" @click="showModal(`Confirm password to unprotect ''${item.name}''`, 'unprotect', item)">Unprotect</b-dropdown-item>
                                        <b-dropdown-item href="javascript:void(0)" @click="showModal(`Change Password for ''${item.name}''`, 'changePassword', item)">Change Password</b-dropdown-item>
                                        <b-dropdown-item href="javascript:void(0)" @click="showModal('Confirm profile password for recovery', 'forgotmatch', item)">Forgot Password</b-dropdown-item>
                                    </template>
                                </template>
                                <b-dropdown-item v-if="item.dataType === 'folders' && !(('hasPassword' in item) && item.hasPassword)" href="javascript:void(0)" @click="store.useDownloadStore.downloadFoldersFiles(item.encryptedId, item)">Download</b-dropdown-item>
                                <b-dropdown-item v-if="item.dataType === 'files' && !(('hasPassword' in item) && item.hasPassword)" :href="item.viewUrl" :download="item.name">Download</b-dropdown-item>
                            </template>
                        </b-dropdown>
                    </div>   
                </div>
                <a v-if="item.dataType === 'files'" @click="checkClickEvent(item, $event)" href="javascript:void(0)" class="text-body">
                    <div class="avatar-xs me-3 mb-3">
                        <div class="avatar-title bg-transparent rounded">
                           <i class="font-size-24 text-warning" :class="item.gridDocIcon"></i>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="overflow-hidden me-auto flex-fill">
                            <h5 class="font-size-14 text-break w-100 mb-1">
                                <span v-if="isEdit">
                                    <form @submit.prevent="disableEditMode(true)">
                                        <div class="input-group">
                                            <input ref="rename" class="form-control border border-0 border-bottom rounded-0 border-primary border-2 p-0" placeholder="Enter new name" required v-model="renameFolderFile.file_name"/>
                                            <div class="input-group-addon">
                                                <button type="submit" class="btn-custom"><i class="font-size-20 text-success mdi mdi-check"></i></button>
                                                <i @click="disableEditMode(false)" class="font-size-20 text-danger mdi mdi-close"></i>
                                            </div>
                                        </div>
                                    </form>
                                </span>
                                <span class="d-flex align-items-center gap-1" v-else>
                                    <i v-if="(('protected' in item) && item.protected) || (('hasPassword' in item) && item.hasPassword)" class="mdi mdi-lock text-secondary"></i>
                                    <div @click="checkClickEvent(item, $event, 1)">{{ item.name.split(".").slice(0, -1).join(".").length > 27 ? `${item.name.split(".").slice(0, -1).join(".").substring(0, 27).concat('  ...')}` : item.name }}</div>
                                </span>                           
                            </h5>
                            <div class="d-flex flex-row align-items-center justify-content-between">
                                <p class="text-truncate mb-0">{{ item.size }}</p>                  
                                <i 
                                    v-if="item.sharedBy"
                                    :id="`popover-file-info-reactive${index}`"
                                    @click.stop
                                    class="mdi mdi-information-outline fs-5 text-info ms-auto"
                                >
                                </i>
                                <b-popover
                                    v-if="item.sharedBy"
                                    :target="`popover-file-info-reactive${index}`" 
                                    variant="info" 
                                    triggers="hover"
                                >
                                    <template #title>
                                        <span class="text-dark">Shared By</span>
                                    </template>
                                    <span>{{ item.sharedBy }}</span>
                                </b-popover>
                            </div>
                        </div>
                    </div>
                </a>
                <a v-else @click="checkClickEvent(item, $event)" href="javascript:void(0)"  class="text-body">
                    <div class="avatar-xs me-3 mb-3">
                        <div class="avatar-title bg-transparent rounded">
                            <i class="font-size-24" :class="[item.gridDocIcon, dataType === 'Own' || dataType === 'OwnContent' ? 'text-warning' : 'text-primary']"></i>
                        </div>
                    </div>
                    <div class="d-flex">
                        <div class="overflow-hidden me-auto flex-fill">
                            <h5 class="font-size-14 text-break w-100 mb-1">
                                <span v-if="isEdit">
                                    <form @submit.prevent="disableEditMode(true)">
                                        <div class="input-group">
                                            <input ref="rename" class="form-control border border-0 border-bottom rounded-0 border-primary border-2 p-0" placeholder="Enter new name" required v-model="renameFolderFile.doc_name"/>
                                            <div class="input-group-addon">
                                                <button type="submit" class="btn-custom"><i class="font-size-20 text-success mdi mdi-check"></i></button>
                                                <i @click="disableEditMode(false)" class="font-size-20 text-danger mdi mdi-close"></i>
                                            </div>
                                        </div>
                                    </form>
                                </span>
                                <span class="d-flex align-items-center gap-1" v-else>
                                    <i v-if="(('protected' in item) && item.protected) || (('hasPassword' in item) && item.hasPassword)" class="mdi mdi-lock text-secondary"></i>
                                    <div @click="checkClickEvent(item, $event, 1)">{{ item.name.length > 27 ? `${item.name.substring(0, 27).concat('  ...')}` : item.name }}</div>
                                </span>                            
                            </h5>
                            <div class="d-flex flex-row align-items-center justify-content-between">
                                <p class="text-truncate mb-0">{{ item.size }}</p>
                                <i 
                                    v-if="item.sharedBy"
                                    :id="`popover-folder-info-reactive${index}`"
                                    @click.stop
                                    class="mdi mdi-information-outline fs-5 text-info ms-auto"
                                >
                                </i>
                                <b-popover
                                    v-if="item.sharedBy"
                                    :target="`popover-folder-info-reactive${index}`" 
                                    variant="info" 
                                    triggers="hover"
                                >
                                    <template #title>
                                        <span class="text-dark">Shared By</span>
                                    </template>
                                    <span>{{ item.sharedBy }}</span>
                                </b-popover>
                            </div>
                        </div>
                    </div>
                </a>
        </div>
    </div>
</template>

<style scoped>
    .blink {
    animation: blinking ease-out 1s 5;
    }

    @keyframes blinking {
    0% {
        background-color: #06c3d1;
    }
    100% {
        background-color: #fff;
    }
    }
    .btn-custom {
        background-color: transparent;
        border: none;
        outline: none;
        padding:0.1rem;
        margin:0;
    }
</style>
